<template>
  <transition name="fade" mode="out-in">
    <div v-if="page === 'register'" class="w-full">
      <h3 v-if="registerTitle" class="text-center mb-2">
        {{ registerTitle }}
      </h3>

      <p v-if="registerDescription" class="text-sm mb-8">
        {{ registerDescription }}
      </p>

      <RegisterForm
        key="register"
        :oauth-params="oauthParams"
        :button-text="buttonText"
        :show-name-fields="false"
        @register="$emit('authenticated')"
        @goToLogin="page = 'login'"
      />
    </div>

    <div v-else-if="page === 'login'" class="w-full">
      <h3 v-if="loginTitle" class="text-center mb-2">
        {{ loginTitle }}
      </h3>

      <p v-if="loginDescription" class="text-sm mb-8">
        {{ loginDescription }}
      </p>

      <LoginForm
        key="login"
        :oauth-params="oauthParams"
        :button-text="buttonText"
        @login="$emit('authenticated')"
        @goToRegister="page = 'register'"
      />
    </div>

    <!-- form loader, attemps to emulate buttons/field positions -->
    <div v-else class="space-y-8">
      <div class="mx-auto" style="max-width: 10rem;">
        <ContentLoader :height="100" />
      </div>

      <div class="grid gap-6">
        <ContentLoader :height="40" />

        <div class="grid grid-cols-2 gap-4">
          <ContentLoader :height="175" />
          <ContentLoader :height="175" />
        </div>

        <ContentLoader :height="100" />
        <ContentLoader :height="100" />
        <ContentLoader :height="100" />
      </div>

      <ContentLoader :height="25" />
    </div>
  </transition>
</template>

<script>
import ContentLoader from '@/components/loader/ContentLoader'
import RegisterForm from '@/components/Account/RegisterForm'
import LoginForm from '@/components/Account/LoginForm'
import { useUser } from '@/lib/hooks'

export default {
  components: { ContentLoader, RegisterForm, LoginForm },

  props: {
    startingPage: { type: String, default: 'register' },
    registerDescription: { type: String, default: '' },
    loginDescription: { type: String, default: '' },
    registerTitle: { type: String, default: '' },
    loginTitle: { type: String, default: '' },
    buttonText: { type: String, default: '' },
    oauthParams: { type: Object, default: () => ({}) },
  },

  data: () => ({ page: 'register' }),

  async mounted() {
    this.page = 'loading'

    const { getUser } = useUser(this.$api)
    const user = await getUser().catch(() => null)

    if (user) {
      this.$emit('alreadyAuthenticated')

      return
    }

    this.page = this.startingPage
  },
}
</script>
